/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator>): InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator {
        let obj = Object.assign(new InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator(), model);
        InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator>): InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator {
        if (!model) return null;
        return InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator.newInstance(<InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator) {
        if (!obj) return;

        models.InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches if any of the image's tags starts with this value
     */
    starts_with: string;

}
